import React, { useState } from "react";
import { Box, Button, Center, Loader, Text } from "@mantine/core";
import ClientTabs from "./components/clientTabs/clientTab";
import { useClientOverview } from "api/client/getClientProfile";
import ClientDashboard from "./components/clientInformation/clientInformation";
import ProjectsCard from "./components/projects/projectCard";
import { useParams } from "react-router-dom";

export default function ClientProfile() {
  const { clientId } = useParams<{ clientId: string }>();

  const { data, isLoading, isError } = useClientOverview(clientId!);

  // const handleClientNavigate = () => {
  //   navigate("/client");
  // };
  if (isLoading) {
    return (
      <Center style={{ height: 300 }}>
        <Loader size="lg" />
      </Center>
    );
  }

  if (isError || !data) {
    return (
      <Center style={{ height: 300, flexDirection: "column", gap: 8 }}>
        <Text color="red" weight={500}>
          Failed to load client data.
        </Text>
        <Button onClick={() => window.location.reload()}>Retry</Button>
      </Center>
    );
  }
  return (
    <Box p="lg" style={{ minHeight: "100vh" }}>
      <ClientDashboard client={data.client} overview={data.overview} />
      <ProjectsCard
        // userId={data || ""}
        projects={data?.projects}
        // onOpenDashboard={() => {
        //   setTabValue("clientDasboard");
        //   setTitle(false);
        // }}
      />
    </Box>
  );
}
